'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const { parse } = require('../../modules/support/localisation-parser');

function Footer() {
  return h(WithI18n, {}, i18n =>
    h('.footer', {
      dangerouslySetInnerHTML: {
        __html: parse(i18n.t('modules.shared.FooterText')),
      },
    })
  );
}

module.exports = Footer;
